<script lang="ts" setup>
  import SectionBackground from '~/components/loggedOutNew/SectionBackground.vue';

  const { activeBreakpoint } = useDeviceType();
  const isMobile = computed(() => ['xxs', 'xs', 'sm'].includes(activeBreakpoint.value));
</script>

<template>
  <section class="@container/oeg w-full relative rounded-[10px] overflow-hidden">
    <SectionBackground />

    <!-- section content -->
    <div
      class="relative flex flex-col md:flex-row md:max-h-[295px] lg:max-h-[487px] xl:max-h-[670px] 2xl:max-h-[738px]"
    >
      <div class="w-full min-h-[260px] md:hidden">
        <NuxtImg
          v-if="isMobile"
          alt=""
          class="block md:hidden w-full mb-[-120px]"
          fit="cover"
          format="webp"
          src="/images/lo-hp/mini-cards-image-mobile.webp"
          :placeholder="['100vw', '100%', 90, 1]"
          preload
          eager
        />
      </div>

      <div
        class="relative z-10 flex flex-col items-center gap-6 px-[21px] py-10 md:px-6 md:py-6 lg:pr-0 xl:px-10 xl:py-10 2xl:px-[60px] 2xl:py-[60px] md:gap-[14px] md:basis-1/2 min-[61.25rem]:basis-3/5 md:shrink-0 xl:basis-1/2 desktop-1660:max-w-[40%] desktop-1660:gap-9"
      >
        <h2
          class="w-full font-barlow text-white text-left font-extrabold leading-[100%] uppercase not-italic text-[3.25rem] md:text-[1.5625rem] min-[61.25rem]:text-[2.25rem] lg:text-[3rem] xl:text-[4rem]"
        >
          ORIGINAL & EXCLUSIVE GAMES
        </h2>

        <p
          class="text-left text-white font-medium text-base md:text-[0.65rem] min-[61.25rem]:text-xs lg:text-base xl:text-[1.375rem] leading-[130%] md:leading-[135%] font-barlow not-italic"
        >
          Experience PvP versions of your favorite games and play against others in a "winner take all" format to take
          the entire Prize Pot!
          <br />
          <br />
          MaxDuel is the ultimate Player vs Player (PvP) game platform where you compete in original games of skill for
          real cash prizes.
        </p>

        <div class="flex flex-col gap-1 w-full mt-[1.125rem] text-left">
          <p
            class="m-0 p-0 text-white not-italic font-extrabold leading-none uppercase text-shadow-[var(--shadow-medium)] flex items-center text-[1.3125rem] xxs:text-[1.4375rem] tracking-[0.46px] md:text-xl lg:text-[1.85rem] desktop-1660:text-[2.1875rem]"
          >
            PROVABLY
            <span
              class="pl-1 sm:pl-2 text-[1.625rem] xxs:text-[1.75rem] italic tracking-[0.56px] translate-y-[-1px] md:text-[1.625rem] lg:text-[2.375rem] desktop-1660:text-[2.75rem]"
            >
              FAIR GAMES -
            </span>
          </p>
          <p
            class="m-0 p-0 text-white not-italic font-extrabold leading-none uppercase text-shadow-[var(--shadow-medium)] text-[1.4375rem] tracking-[0.46px] md:text-xl lg:text-[1.85rem] desktop-1660:text-[2.1875rem]"
          >
            <span>A PAYOUT IN</span>
            <br class="mobile-448:hidden md:block" />
            <span
              class="text-[#5bb5fa] text-[2.125rem] not-italic font-extrabold leading-none tracking-[0.68px] uppercase mobile-448:ml-2 md:ml-0 md:text-[2rem] lg:text-[2.875rem] desktop-1660:text-[3.3125rem]"
            >
              EVERY ROUND!
            </span>
          </p>
        </div>
      </div>

      <div
        v-if="!isMobile"
        class="hidden md:flex md:justify-end md:basis-3/5 xl:basis-full lg:shrink-0 lg:absolute lg:right-0 lg:top-0 lg:bottom-0 lg:translate-x-1/6 xl:translate-x-1/3 desktop-1660:translate-x-0"
      >
        <CoreImage
          alt=""
          class="min-h-full"
          format="avig"
          sizes="md:360px lg:840px"
          preload
          eager
          src="/images/lo-hp-new/mini-cards-image-desktop.webp"
        />
      </div>
    </div>
  </section>
</template>
